







































import axios from 'axios'
import conf from '../../../config'
import myPrizeMod from './myPrizeMod.vue'
import qrCodeMod from './qrCodeMod.vue'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import openApp from '@ivy/fts/openApp'
import * as utils from '@ivy/fts/utils'
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import * as envInfo from '@ivy/fts/envInfo/envInfo'
import * as util from '../util'
import { appGolbal } from '@ivy/fts/appGlobal'
import { cacheSet } from '@ivy/fts/utils'
const env = envInfo.env
@Component({
  filters: {
    getPrizeDesc(prize) {
      return prize.product_data
      // if (prize.product_type === '会员') {
      //   return this.isWeixin ? '现在已经为您开通了相应权限，您现在就可以下载“常青藤爸爸”APP并在其中查看使用了。' : '现在已经为您开通了相应权限，现在就可以在APP中查看使用了。'
      // } else {
      //   return prize.product_type === '有赞优惠券' || prize.product_type === '常爸优惠券' ? `请前往“常青藤爸爸APP”，在我的-优惠券-领取优惠券中领取使用。` : `您获得的为实体奖品，请您完善收货信息。我们将会在10个工作日内为您寄出。您也可以稍后在“我的奖品”中进行完善信息。`
      // }
    },
  },
})
export default class ShowPrizeMod extends Vue {
  @Prop() close: any
  @Prop() exchange: any
  @Prop() prize: any
  @Prop() prize2: any
  @Prop() backgroundColor: any

  isWeixin: any = utils.isWeixin()
  canSubmit: boolean = true
  goodsInfo: any = {}
  orderInfo: any = {}
  directRewardType = ['会员', '青豆']
  record: any = {}
  async goNow() {
    if (this.prize.product_type === '常爸优惠券') {
      if (env.type === 'ivydad') {
        this.close()
      }
      return await env.commonJump(
        'ivydadreadtool://my/coupon?type=other&index=0'
      )
    }
    if (this.prize.product_type === '有赞优惠券') {
      // this.prize && this.prize.yz_coupon_url ? (window.location.href = `${this.prize.yz_coupon_url}`) : this.openApp()
      return (window.location.href = `${this.prize.yz_coupon_url}`)
    }
    if (this.prize.product_type === '小助手二维码') {
      this.close()
      return await showDiv(qrCodeMod, {
        backgroundColor: this.backgroundColor,
        qrImage: this.prize.assistant_qr_url,
      })
    }
    if (
      this.prize.product_type === '英语课' ||
      this.prize.product_type === '亲子课'
    ) {
      this.close()
      return this.$Toast('请在“APP-我的-已购买的-课程”中查看')
      // const host = conf.env === 'production' ? `https://m.ivydad.com` : `http://m.ivydad.com.cn`
      // return window.location.href = `${host}/center/index`
    }
    let giftPhysical = await util.judgeGiftPhysical(
      this.prize.product_type,
      this.prize.launch_id
    )
    if (
      this.prize.product_type === '商品' ||
      this.prize.product_type === '商品组'
    ) {
      let { record, goodsInfo } = await util.getGoodsInfo(
        this.prize.product_type,
        this.prize.launch_id,
        this.prize.record_id
      )
      this.record = record
      this.goodsInfo = goodsInfo
      if (goodsInfo.type !== 'physical' && !giftPhysical) {
        this.orderInfo = await util.submit(record)
        if (!this.orderInfo.order_id) return this.$Toast(`领取失败`)
        await util.updateRewardMemStatus(null, this.prize.armId)
        this.$Toast('领取成功')
        this.exchange(this.prize)
        return this.close()
      }
    }
    let href = window.location.href
    let cur_url = `${href}${href.includes('?') ? '&' : '?'}exchangeIndex=0`
    let receiverId = this.$route.query.receiver_id // 收货地址id
    if (!receiverId) {
      let token
      if (env.type === 'ivydad') {
        await appGolbal.init()
        let appInfo = await appGolbal.nativeGetInfo('all')
        token = appInfo && appInfo.userInfo && appInfo.userInfo.token
      } else {
        token = await env.getToken()
      }
      cacheSet(`token-${conf.appid}`, token)
      const host =
        conf.env === 'production'
          ? `https://m.ivydad.com`
          : `http://m.ivydad.com.cn`
      return (window.location.href = `${host}/center/address/addressList?mode=select&token=${token ||
        ''}&redirect=${encodeURIComponent(cur_url)}`)
    }
    // let r = await axios.post(`/api/mobile/activity/luckyDraw/modifyMyPrize`, { id: this.prize2.armId, is_receive: 1 }) // 改变兑换状态
    let info = await env.getInfo()
    if (this.goodsInfo.type === 'physical' || giftPhysical) {
      this.orderInfo = await util.submit(this.record)
      if (!this.orderInfo.order_id) return this.$Toast(`领取失败`)
      await util.updateRewardMemStatus(receiverId, this.prize.armId)
      await util.addReceiverId(
        receiverId,
        this.orderInfo.order_id,
        this.orderInfo.tid
      )
      this.$Toast('领取成功')
      this.exchange(this.prize)
      return this.close()
    }
    let result = await axios.post(`/api/mobile/activity/luckyDraw/goodRecord`, {
      reward: this.prize,
      receiverId,
      ...info.publicParams,
    }) // 记录发货表lu
    if (result) {
      this.exchange(this.prize)
      this.$Toast(`领取成功`)
    } else {
      this.$Toast(`领取失败`)
    }
    this.close()
  }
  async openApp() {
    this.isWeixin ? openApp() : this.close()
  }
}
